/* * Version: 1.0.0
 * Letzte Änderung: 16.09.2026, 12:50
 * Änderungshistorie: Erstellung des Route-Guards zur Absicherung interner Screens.
 * Copyright: BAIT-Tech
 */
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = () => {
  // Wir holen uns den aktuellen Login-Status aus dem globalen Context
  const { userInfo } = useContext(AuthContext);

  // Wenn der Benutzer eingeloggt ist (userInfo existiert), rendern wir die angeforderte Route (<Outlet />).
  // Wenn kein Login existiert, fangen wir den Nutzer ab und leiten ihn per <Navigate> zur Login-Seite.
  // Das 'replace' Attribut verhindert, dass der Nutzer über den "Zurück"-Button im Browser auf die leere, blockierte Seite kommt.
  return userInfo ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;